;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { booleanEnvironmentSchema } from '@qogita/validation/environment'
import { requiredString } from '@qogita/validation/string'

const NEXT_PUBLIC_POSTHOG_ENABLED = booleanEnvironmentSchema()
  .default(false)
  .parse(process.env.NEXT_PUBLIC_POSTHOG_ENABLED)

export const posthogConfig = NEXT_PUBLIC_POSTHOG_ENABLED
  ? {
      enabled: true as const,
      projectToken: requiredString(
        'NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN missing from environment',
      ).parse(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN),
      host: requiredString(
        'NEXT_PUBLIC_POSTHOG_HOST missing from environment',
      ).parse(process.env.NEXT_PUBLIC_POSTHOG_HOST),
    }
  : { enabled: false as const }
